import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HomeComponent} from './public/home/home.component';
import {PageNotFoundComponent} from './public/page-not-found/page-not-found.component';
import {PublicContainerComponent} from './public/public-container/public-container.component';
import {PrivateContainerComponent} from './private/private-container/private-container.component';
import {DashboardComponent} from './private/dashboard/dashboard.component';
import {ReservedRoutesGuard} from './guards/reserved-routes.guard';
import {ListCompaniesComponent} from './private/companies/list-companies/list-companies.component';
import {ProfileManagementComponent} from './private/profile/profile-management/profile-management.component';
import {ListContractsComponent} from "./private/contracts/list-contracts/list-contracts.component";
import {ListTestbedsComponent} from "./private/testbeds/list-testbeds/list-testbeds.component";
import {ListBoxesComponent} from "./private/boxes/list-boxes/list-boxes.component";
import {ListSimsComponent} from "./private/sims/list-sims/list-sims.component";
import {ListBoxInterfacesComponent} from "./private/box-interfaces/list-box-interfaces/list-box-interfaces.component";
import {ListStorageComponent} from "./private/storage/list-storage/list-storage.component";
import {
  ClientDownloadPageComponent
} from './private/client-download/client-download-page/client-download-page.component';

import {Constants} from "./utils/constants";
import {EmailVerificationComponent} from './public/email-verification/email-verification.component';
import {UserProfileComponent} from './private/profile/user-profile/user-profile.component';
import {TestOutputPageComponent} from './private/test/test-output-page/test-output-page.component';
import {TestListPageComponent} from './private/test/test-list-page/test-list-page.component';
import {ExecuteListComponent} from './private/execute-list/execute-list.component';
import {LoginComponent} from "./public/login/login.component";
import {AddTestImageComponent} from './private/test-image/add-test-image/add-test-image.component';
import {ListTestImageComponent} from './private/test-image/list-test-image/list-test-image.component';
import {PreventRouteOnKeycloakGuard} from "./guards/prevent-route-on-keycloak.guard";
import {ListUsersComponent} from "./private/users/list-users/list-users.component";
import {BoxConfigurationPageComponent} from "./private/boxes/box-configuration-page/box-configuration-page.component";


const routes: Routes = [
  {
    path: '',
    component: PublicContainerComponent,
    children: [
      {path: '', component: HomeComponent},
      {path: 'login', component: LoginComponent, canActivate: [PreventRouteOnKeycloakGuard]},
      {path: 'email-verification', component: EmailVerificationComponent}
      // {path: 'registration', component: CompanyFormComponent, data: {isRegistrationRequest: true}}
    ]
  },
  {
    path: 'reserved',
    canActivate: [ReservedRoutesGuard],
    component: PrivateContainerComponent,
    children: [
      {path: '', component: DashboardComponent},
      {
        path: 'add-test-image/:companyId', component: AddTestImageComponent,
        canActivate: [ReservedRoutesGuard],
        data: {permissions: ["admin", "customer"]}
      },
      {
        path: 'test-image', component: ListTestImageComponent,
        canActivate: [ReservedRoutesGuard],
        data: {permissions: ["admin", "customer"]}
      },
      {
        path: 'users',
        canActivateChild: [ReservedRoutesGuard],
        data: {permissions: Constants.permissionsConstants()},
        children: [
          {
            path: '',
            component: ListUsersComponent,
            canActivate: [ReservedRoutesGuard],
            data: {permissions: ["admin", "customer", "tester", "logistic", "researcher"]}
          },
        ]
      },
      {
        path: 'companies',
        children: [
          {
            path: '',
            component: ListCompaniesComponent,
            canActivate: [ReservedRoutesGuard],
            data: {permissions: ["admin"]}
          },
          {
            path: 'execute',
            component: ExecuteListComponent,
            canActivate: [ReservedRoutesGuard],
            data: {permissions: ["tester", "customer", "admin"]}
          },
          {path: ':companyId/"customer"s', component: ListUsersComponent},
        ]
      },
      {
        path: 'storage',
        children: [
          {
            path: '',
            component: ListStorageComponent,
            canActivate: [ReservedRoutesGuard],
            data: {permissions: ["admin"]}
          },
        ]
      },
      {
        path: 'contracts',
        children: [
          {
            path: '',
            component: ListContractsComponent,
            canActivate: [ReservedRoutesGuard],
            data: {permissions: ["admin", "customer", "logistic", "tester"]}
          },
          {
            path: ':id',
            children: [
              {
                path: 'test-list',
                component: TestListPageComponent,
                canActivate: [ReservedRoutesGuard],
                data: {permissions: ["admin", "customer", "tester"]}
              },
              {
                path: 'output-list',
                component: TestOutputPageComponent,
                canActivate: [ReservedRoutesGuard],
                data: {permissions: ["admin", "customer", "tester"]}
              },
            ],
          },
        ]
      },
      {
        path: 'testbeds',
        children: [
          {
            path: '',
            component: ListTestbedsComponent,
            canActivate: [ReservedRoutesGuard],
            data: {permissions: ["admin", "customer"]}
          },
        ]
      },
      {
        path: 'boxes-management',
        canActivateChild: [ReservedRoutesGuard],
        data: {permissions: ["admin", "logistic"]},
        children: [
          {
            path: 'boxes',
            children: [
              {path: '', component: ListBoxesComponent},
              //{ path: ':id/"logistic"s', component: TO_BE_IMPLEMENTED_PLACEHOLDER_COMPONENT }
            ]
          },
          {path: 'sims', component: ListSimsComponent},
          {
            path: 'interfaces',
            children: [
              {path: '', component: ListBoxInterfacesComponent},
            ]
          },
          {
            path: 'configuration',
            component: BoxConfigurationPageComponent,
            canActivate: [ReservedRoutesGuard],
            data: {
              permissions: [
                "admin",
                "customer"
              ]
            }
          },
        ]
      },
      {
        path: 'profile',
        children: [
          {path: "", component: UserProfileComponent},
          {path: "edit", component: ProfileManagementComponent}
        ]
      },
      {
        path: 'client-download',
        component: ClientDownloadPageComponent,
        canActivate: [ReservedRoutesGuard],
        data: {permissions: ["researcher"]}
      },

    ]
  },
  {path: 'not-found', component: PageNotFoundComponent},
  {path: '', redirectTo: '', pathMatch: 'full'},
  {path: '**', component: PageNotFoundComponent},
  // {path: '**', redirectTo: 'not-found'},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}
